import { Link, Navigate, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { reportActorKey, useCurrentUser } from '@/api/hooks'
import { liveApiClient } from '@/api/live-query'
import { Button } from '@/components/ui/button'

function ResolveSeries({ showId }: { showId: string }) {
  const user = useCurrentUser()
  const lookup = useQuery({
    queryKey: ['show-series', 'for-show', showId, ...reportActorKey(user.data)],
    queryFn: () => liveApiClient.lookupShow({ showId }),
    staleTime: 0,
    refetchOnMount: 'always',
    retry: false,
    networkMode: 'always',
  })
  if (lookup.isError)
    return (
      <div role="alert" className="space-y-3">
        <p>Unable to check this show's current series.</p>
        <Button onClick={() => void lookup.refetch()}>Retry series lookup</Button>
        <Link className="underline" to="/show-series">
          Browse show series
        </Link>
      </div>
    )
  if (!lookup.isFetchedAfterMount || lookup.isFetching || !lookup.data) {
    return <p role="status">Checking the show's current series…</p>
  }
  const series = lookup.data.show.seriesMembership?.series
  return <Navigate replace to={series ? `/show-series/${series.id}/reports` : '/show-series'} />
}

export default function ShowSeriesRedirect() {
  const { showId } = useParams<{ showId: string }>()
  const user = useCurrentUser()
  if (!user.data || !showId) return <p role="status">Checking series access…</p>
  return (
    <ResolveSeries key={`${showId}:${JSON.stringify(reportActorKey(user.data))}`} showId={showId} />
  )
}
